import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProjectService } from 'src/app/services/project.service';
import Project from 'src/app/interfaces/Project';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Subscription, BehaviorSubject } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { ToastService } from 'src/app/services/toast.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-project-single',
  templateUrl: './project-single.component.html',
  styleUrls: ['./project-single.component.scss'],
})
export class ProjectSingleComponent implements OnInit, OnDestroy {
  constructor(
    private projectService: ProjectService,
    private route: ActivatedRoute,
    private userService: UserService,
    private toastService: ToastService,
    private analyticsService: AnalyticsService,
    private notificationService: NotificationsService
  ) {}
  project$;
  project;
  allMembers = new BehaviorSubject(null);
  activeMembers;
  subscriptions: Subscription = new Subscription();
  currentUser;
  membershipInactive;
  membershipPending;

  ngOnInit() {
    this.analyticsService.event('project_profile_view');
    this.project$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => this.projectService.getCurrentProject(params.get('id')))
    );
    this.project$.subscribe((p) => {
      this.project = p[0];

      this.projectService.getProjectMembers(this.project.id).subscribe((m) => {
        this.allMembers.next(m);
        this.activeMembers = m.filter((m) => m.projectRoles[this.project.id].status === 'active');
      });

      // Get user
      this.subscriptions.add(
        this.userService.user.subscribe((u) => {
          if (u && u.uid) {
            this.currentUser = u;
            this.membershipInactive = this.currentUser.projects.indexOf(this.project.id) === -1;
            this.membershipPending =
              this.currentUser.projectRoles[this.project.id] &&
              this.currentUser.projectRoles[this.project.id].status === 'pending';
          }
        })
      );
    });
  }

  addProjectToProfile() {
    this.analyticsService.event('project_profile_add_click');
    if (this.currentUser.projects.indexOf(this.project.id) === -1) {
      this.currentUser.projects.push(this.project.id);
      this.currentUser.projectRoles[this.project.id] = {
        role: 'member',
        status: 'pending',
      };
      this.userService.saveUser(this.currentUser.uid, this.currentUser).then(() => {
        this.projectService.getProjectMembers(this.project.id).subscribe((m) => {
          this.allMembers.next(m);
          this.project.allMembers = this.allMembers;
          this.activeMembers = m.filter((m) => m.projectRoles[this.project.id].status === 'active');
          this.toastService.setToast(
            '<b>Success!</b> We’ve sent your request to join ' + this.project.projectName + '.'
          );
          this.notificationService.sendNotifications({
            type: 'joinProject',
            owner: this.project.owner,
            currentUser: this.currentUser.displayName,
            url: `/projects/${this.project.id}`,
          });
          this.notificationService.saveNotification(
            this.project.owner,
            this.currentUser.uid,
            `requests to join <a href="/projects/${this.project.id}">your project</a>`,
            this.currentUser.displayName,
            this.currentUser.profilePicture
          );
        });
      });
    }
  }

  headingEvent(e) {
    if (e === 'leave') {
      this.removeProjectFromProfile();
    }
  }

  removeProjectFromProfile() {
    const index = this.currentUser.projects.indexOf(this.project.id);
    this.currentUser.projects.splice(index, 1);
    delete this.currentUser.projectRoles[this.project.id];
    this.userService.saveUser(this.currentUser.uid, this.currentUser).then(() => {
      this.toastService.setToast('Successfully left ' + this.project.projectName);
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
